var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.visible,
            width: "400px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px" } },
            [
              _vm.actionType === "hq_allocate"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "分公司：" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.formData.groupId,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "groupId", $$v)
                            },
                            expression: "formData.groupId",
                          },
                        },
                        _vm._l(_vm.groupList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.actionType === "branch_allocate"
                ? _c(
                    "el-form-item",
                    { attrs: { label: "业务员：" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.formData.salesId,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "salesId", $$v)
                            },
                            expression: "formData.salesId",
                          },
                        },
                        _vm._l(_vm.salesList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitLoading },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }